angular.module('picmonicng').factory('DashboardTilesConfig', [
  '$filter',
  'UserService',
  function ($filter, UserService) {
    var tileTypes = [
      {
        icon: 'playlist_play',
        label: 'My Playlists',
        type: 'playlists',
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'av_timer',
        label: 'Recently Viewed',
        type: 'recent',
        hidden: 0,
        locked: 0,
      },
      {
        img: 'lightbulb.svg',
        label: 'Updated Picmonics',
        type: 'updated',
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'av_timer',
        label: 'Recommended For Me',
        type: 'recommended',
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'update',
        label: 'Daily Quiz With Spaced Repetition',
        type: 'spaced-rep',
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'trending_up',
        label: 'Trending Picmonics',
        type: 'trending',
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'insert_chart',
        label: 'Quiz Performance',
        type: 'stats',
        priority: 1,
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'show_chart',
        label: 'Weakest Picmonics',
        type: 'weakest',
        hidden: 0,
        locked: 0,
      },
      {
        icon: 'group',
        label: 'Group Buy',
        type: 'groupbuy',
        hidden: 1,
        locked: 1,
      },
      {
        icon: 'drive_eta',
        label: 'Road Trip Sourcing',
        type: 'rt-sourcing',
        hidden: 1,
        locked: 0,
      },
      //{img: 'beta_features.svg', label:'Beta Features', type: 'character-library', hidden: 0, locked: 0},
      {
        icon: 'today',
        label: 'Presentations',
        type: 'presentations',
        hidden: 1,
        hide_selector: 1,
        locked: 0,
      },
      {
        icon: 'screen_share',
        label: 'Webinars',
        type: 'webinars',
        hidden: 1,
        hide_selector: 1,
        locked: 0,
      },
      {
        img: 'logos/logo.svg',
        label: 'Daily Goal',
        type: 'daily-goal',
        hidden: 1,
        hide_selector: 0,
        locked: 1,
      },
      {
        img: 'icons/achievements.svg',
        label: 'Achievements',
        type: 'achievements',
        hidden: 1,
        hide_selector: 0,
        locked: 1,
      },
      {
        img: 'icons/achievements.svg',
        label: 'Leaderboard',
        type: 'leaderboard',
        hidden: 1,
        hide_selector: 1,
        locked: 1,
      },
    ];

    if (UserService.user.role === 'Professor' || UserService.user.role === 'Alumni') {
      tileTypes.push({
        icon: 'pie_chart',
        label: 'Research Proven',
        type: 'research',
        locked: 0,
      });
      tileTypes.push({
        icon: 'play_circle_outline',
        label: 'Intro to Picmonic',
        type: 'intro-picmonic',
        hidden: 0,
        locked: 0,
      });
      tileTypes.push({
        icon: 'play_circle_outline',
        label: 'Contact Us',
        type: 'contact-us',
        hidden: 0,
        locked: 0,
      });
    }

    return tileTypes;
  },
]);
